export default __webpack_public_path__ + "static/media/collections_9.a86abb4f.jpg";